import { QueryList, EventEmitter } from '@angular/core';
import { AutoGroupSourceItemComponent } from './auto-group-source-item/auto-group-source-item.component';
import { CommonConstant } from '../../../../app.constants';
import { AutoGroupSource, AutoGroupSourceEnum } from '../../../../../models/auto-group/auto-group-setting';
import { UserService } from '../../../../services/user.service';
import { BrandedSignUp } from '../../../../../models/auto-group/branded-sign-up';
import { CacheService } from '../../../../services/cache/cache.service';
var AutoGroupSourcesComponent = /** @class */ (function () {
    function AutoGroupSourcesComponent(userService, cacheService) {
        this.userService = userService;
        this.cacheService = cacheService;
        this.autoGroupSourceList = [];
        this.listProject = [];
        this.campaignList = [];
        this.influencerGroupList = [];
        this.autoGroupSource = [];
        this.showSourceRequiredErrorMessageChange = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.autoGroupSourceItem = new AutoGroupSource();
        this.availableAutoGroupSourceList = [];
    }
    AutoGroupSourcesComponent.prototype.ngOnInit = function () {
        this.loadGroupSourceData();
        this.loadSourceList();
    };
    AutoGroupSourcesComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.autoGroupSourceItemList.forEach(function (sourceItem) { return _this.changeGroupSourceEvent(sourceItem.sourceItem); });
        }, 100);
    };
    AutoGroupSourcesComponent.prototype.loadSourceList = function () {
        this.availableAutoGroupSourceList = this.autoGroupSourceList;
    };
    AutoGroupSourcesComponent.prototype.loadGroupSourceData = function () {
        var _this = this;
        this.cacheService.get(CommonConstant.BRANDED_SIGNUP_CONFIG_KEY + "_" + this.userService.getCompanyId(), this.userService.getSignUpPageData(this.userService.getCompanyId())).subscribe(function (res) {
            if (!res) {
                if (!_this.autoGroupSource || (_this.autoGroupSource && _this.autoGroupSource.length === 0)) {
                    _this.autoGroupSource = [_this.autoGroupSourceItem];
                }
            }
            else {
                var grouSourceItem = new AutoGroupSource();
                grouSourceItem.type = AutoGroupSourceEnum.BRANDED_SIGNUP;
                if (res.influencerGroupId !== _this.influencerGroupId) {
                    return;
                }
                if (!_this.autoGroupSource || (_this.autoGroupSource && _this.autoGroupSource.length === 0)) {
                    _this.autoGroupSource.push(grouSourceItem);
                }
                else {
                    if (_this.autoGroupSource.filter(function (item) { return item.type === AutoGroupSourceEnum.BRANDED_SIGNUP; }).length > 0) {
                        return;
                    }
                    _this.autoGroupSource.unshift(grouSourceItem);
                }
            }
        });
    };
    AutoGroupSourcesComponent.prototype.addMoreGroupSources = function () {
        if (this.autoGroupSource.length >= CommonConstant.MAX_AUTO_GROUP_SOURCE) {
            return;
        }
        this.autoGroupSourceItem = new AutoGroupSource();
        this.autoGroupSource.push(this.autoGroupSourceItem);
        this.showSourceRequiredErrorMessage = false;
        this.showSourceRequiredErrorMessageChange.emit(false);
    };
    AutoGroupSourcesComponent.prototype.changeGroupSourceEvent = function (evt) {
        this.calculateSupportedSourceList();
    };
    AutoGroupSourcesComponent.prototype.deleteGroupSourceEvent = function (evt, itemIndex) {
        this.autoGroupSource.splice(itemIndex, 1);
        this.changeGroupSourceEvent(evt);
    };
    Object.defineProperty(AutoGroupSourcesComponent.prototype, "hideAddBtn", {
        get: function () {
            return this.autoGroupSource.length >= CommonConstant.MAX_AUTO_GROUP_SOURCE;
        },
        enumerable: true,
        configurable: true
    });
    AutoGroupSourcesComponent.prototype.validateAllSources = function () {
        var sourceErrors = [];
        this.autoGroupSourceItemList.forEach(function (filter) { return sourceErrors.push.apply(sourceErrors, filter.validateSources()); });
        return sourceErrors;
    };
    AutoGroupSourcesComponent.prototype.editOrCreateProject = function (project) {
        this.editOrCreateProjectEvent.emit(project);
    };
    AutoGroupSourcesComponent.prototype.calculateSupportedSourceList = function () {
        var selectedSourceTypes = this.autoGroupSource.map(function (gf) { return gf.type; });
        this.availableAutoGroupSourceList = this.autoGroupSourceList.filter(function (sc) { return selectedSourceTypes.indexOf(sc.id) < 0; });
    };
    return AutoGroupSourcesComponent;
}());
export { AutoGroupSourcesComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-sources.component.ts.pre-build-optimizer.js